module.exports = __webpack_public_path__ + "static/img/coupon-bg.e562348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity618/coupon-bg.png
// module id = rMmz
// module chunks = 0